export const helperFunction = {
  capitalizeFirstLetter: (string) => {
    return string?.charAt(0).toUpperCase() + string?.slice(1);
  },
};

export const Reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const grid = 6;
export const getItemStyle = (isDragging, draggableStyle, isCheck = false) => {
  const result = {
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,
    textAlign: 'right',
    // position: 'sticky',
    // change background colour if dragging
    background: isDragging ? 'lightgreen' : 'white',

    // styles we need to apply on draggables
    ...draggableStyle,
  };

  if (isCheck) {
    result.background = '#F6F7FE';
  }

  return result;
};

export const getQuestionListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? 'lightblue' : 'lightgrey',
  padding: 8,
  width: 380,
});
export const getQuestionListStyleNew = (isDraggingOver) => ({
  background: isDraggingOver ? 'lightblue' : 'white',
  padding: 8,
  width: '100%',
});

export const getAnswerListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? 'lightblue' : 'lightgrey',
  padding: 4,
  width: 365,
});
export const getAnswerListStyleNew = (isDraggingOver) => ({
  background: isDraggingOver ? 'lightblue' : 'lightgrey',
  padding: 4,
  width: '100%',
});

export const swapdragStyle = (provided, snapshot) => {
  let transform = provided.draggableProps.style.transform;
  console.log('transform', transform);

  if (snapshot.isDragging) {
    let regex = new RegExp('translate\\((.*?)px, (.*?)px\\)');

    let transformValues = regex.exec(provided.draggableProps.style.transform || 'translate(0px, 0px)');

    if (transformValues != null) {
      const x = parseFloat(transformValues[1], 10) - parseFloat(provided.draggableProps.style.left, 10);
      const y = parseFloat(transformValues[2], 10);
      //  parseFloat(provided.draggableProps.style.top, 10);

      transform = `translate(${x}px, ${y}px)`;
      console.log('override', transform);
    }
  }

  const newStyle = {
    ...provided.draggableProps.style,
    transform,
    position: snapshot.isDragging ? 'absolute' : null,
  };

  return newStyle;
};

export const getUserExamHistory = () => {
  const examsStorage = localStorage.getItem('userExamHistory');

  let exams = new Set();

  if (examsStorage) {
    exams = new Set(JSON.parse(examsStorage));
  }

  return exams;
};

export const setUserExamHistory = (categoryId) => {
  let exams = getUserExamHistory();

  exams.add(categoryId);

  localStorage.setItem('userExamHistory', JSON.stringify(Array.from(exams)));
};

export const isExamAttempted = (categoryId) => {
  const exams = getUserExamHistory();

  return exams.has(categoryId);
};

export const getMainBookNameFromClone = (bookName) => {
  if (!bookName.includes('clone')) {
    return undefined;
  }
  const cloneIndex = bookName.indexOf('clone');
  const removeClone = bookName.substring(0, cloneIndex - 1);
  const mainNameArry = removeClone.split('-');
  const lastElement = mainNameArry[mainNameArry.length - 1];
  // try convert to number
  if (!isNaN(lastElement) && lastElement.length > 5) {
    mainNameArry.pop();
  }

  return mainNameArry.join('-');
};

export const getChapterName = (type, name, index, isHeader = false, mainChpaterIndex = 0, totalHeaders = 0) => {
  if (type === 2) {
    if (isHeader) {
      return `${totalHeaders + 1}. ${name}`;
    } else {
      return `${index + 1}. ${name}`;
    }
  } else {
    if (isHeader) {
      return `${mainChpaterIndex + 1}.${index + 1} ${name}`;
    } else {
      return `${index + 1}. ${name}`;
    }
  }
};
